import { useRef } from 'react';
import { useMachine } from '@xstate/react';

import type { ReCaptchaContext } from './ReCaptcha.types';
import { reCaptchaMachine as reCaptchaStateMachine } from './machine';

/**
 * Returns helpers for interactions with the ReCaptcha component
 */
export const useReCaptcha = () => {
  const reCaptchaRef = useRef<ReCaptchaContext>(null);
  const reCaptchaMachine = useMachine(reCaptchaStateMachine);

  return { reCaptchaRef, reCaptchaMachine };
};
